import React from 'react';
import { motion } from 'framer-motion';
import { AnchorIcon } from 'lucide-react';
import { goToCheckout } from '../lib/constants';
interface CtaButtonProps {
  label?: string;
  onClick?: () => void;
  className?: string;
}
// Primary purchase call-to-action. Scrolls to the purchase section by default.
export function CtaButton({
  label = 'Quiero desbloquear el PER',
  onClick,
  className = ''
}: CtaButtonProps) {
  return <motion.button type="button" onClick={onClick ?? goToCheckout} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    scale: {
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} className={`group relative flex w-full items-center justify-center gap-2 rounded-xl bg-[#c8a24a] px-6 py-4 text-center text-base font-extrabold uppercase tracking-wide text-[#061a33] shadow-lg shadow-[#c8a24a]/30 ring-1 ring-[#e6c168] transition-colors hover:bg-[#e6c168] ${className}`} data-id="element-70">
      <AnchorIcon className="h-5 w-5" aria-hidden="true" data-id="element-71" />
      <span data-id="element-72">{label}</span>
    </motion.button>;
}